import { ITeam, ITwoRowGenericSelectorInp, TPlays, TTeam } from '@/types';

export const CHOOSE_TEAMS_INPUTS = (
  homeTeam: ITeam,
  awayTeam: ITeam,
  backTo = ''
): ITwoRowGenericSelectorInp => ({
  topJustify: 'start',
  topOptions: [
    {
      text: homeTeam.abbreviation,
      value: TTeam.HOME,
      img: homeTeam.logoUrl,
      col: 6,
    },
    {
      text: awayTeam.abbreviation,
      value: TTeam.AWAY,
      img: awayTeam.logoUrl,
      col: 6,
    },
  ],
  backTo,
});

export const OFFENSE_DEFENSE_INP = (winningTeamData: ITeam) =>
  ({
    topJustify: 'start',
    topOptions: [
      {
        text: TPlays.OFFENSE,
        img: winningTeamData.logoUrl,
        alt: 'off',
        value: TPlays.OFFENSE,
        col: 6,
      },
      {
        text: TPlays.DEFENCE,
        img: winningTeamData.logoUrl,
        alt: 'def',
        value: TPlays.DEFENCE,
        col: 6,
      },
    ],
  } as ITwoRowGenericSelectorInp);

// kick or recive input
export const KICK_OR_RECEIVE_INP = (winningTeamData: ITeam) =>
  ({
    topJustify: 'start',
    topOptions: [
      {
        text: TPlays.KICK,
        img: winningTeamData.logoUrl,
        alt: '',
        value: TPlays.KICK,
        col: 6,
      },
      {
        text: TPlays.RECEIVE,
        alt: '',
        img: winningTeamData.logoUrl,
        value: TPlays.RECEIVE,
        col: 6,
      },
    ],
  } as ITwoRowGenericSelectorInp);
